import { render, staticRenderFns } from "./StatSectionPreview.vue?vue&type=template&id=08e3bea8&scoped=true&"
import script from "./StatSectionPreview.vue?vue&type=script&lang=js&"
export * from "./StatSectionPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e3bea8",
  null
  
)

export default component.exports